<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      this.$emit('setpage', 11 + (this.item.mls.form_fields ? this.item.mls.form_fields.length : 0));
      this.loading = false;
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Sign paperwork.png')" class="_w-m-350" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Sign paperwork</h3>
        <p class="text-muted" data-aos="fade-zoom-in">In this section we will work on the document signatures required to get your property listed on the MLS. Signatures are usually handled through a third party service and sent to you via email. Continue to the next page for detailed instructions on how this process is handled for your particular MLS.</p>
      </div>

      <div class="row py-5">
        <div class="col-6">

        </div>
        <div class="col-6 text-right">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Next <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
